const updateMemberMemberships = (state, { payload: { memberships } }) => {
	state.memberMemberships = memberships;
};

export default updateMemberMemberships;
